module.exports = __webpack_public_path__ + "img/gift-2-fill.063095b4.svg";